import { render, staticRenderFns } from "./SelectFormatDialog.vue?vue&type=template&id=0bfbca30&scoped=true"
import script from "./SelectFormatDialog.vue?vue&type=script&lang=js"
export * from "./SelectFormatDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectFormatDialog.vue?vue&type=style&index=0&id=0bfbca30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfbca30",
  null
  
)

export default component.exports